import {TranslationModel} from "PlattixUI/core/components/form/InputFields/TranslationPlattixInput";
import i18n from "PlattixUI/PlattixReactCore/i18n";
import {SupportedLanguages} from "PlattixUI/PlattixReactCore/types/Languages";

export function GetTranslation(translationModel: TranslationModel) {
    return translationModel?.translations[i18n.language.toLowerCase()]
        ?? translationModel?.translations['nl']
        ?? SupportedLanguages.map( l => translationModel?.translations[l.code.toLowerCase()]).filter(t => !!t)[0]
        ?? ''
}